import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import moment from 'moment';
import _ from 'lodash';
import compose from 'lodash/fp/compose';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { takeEmployeesSearchQueries, FORM_NAME_EMPLOYEES_SEARCH } from 'src/reducers/searchForm';
import { downloadEmployeeCsv } from 'src/reducers/employees/employeesAsync';
import DownloadCsvInsideForm from '../components/DownloadCsvModal';

const defaultQuery = {
  enrollment_status: '2',
  memo_color_ids: '1_2_3_4_5_6',
  no_memo: '1'
};

const mapStateToProps = state => {
  const queries = takeEmployeesSearchQueries(getFormValues(FORM_NAME_EMPLOYEES_SEARCH)(state));
  const hasConditions = !_.isEqual(_.pickBy(_.omit(queries, ['order', 'page', 'per_page', 'sort'])), defaultQuery);
  return {
    initialValues: {
      encoding: 'UTF-8',
      target: hasConditions ? 'search' : 'all',
      yearTaxSetting: moment().year(),
      useTaxCalculation: '0',
      attachSampleData: false
    },
    queries
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => dispatch(downloadEmployeeCsv(data, ownProps))
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: EMPLOYEE_FORM
  })
)(DownloadCsvInsideForm);
